import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const page = Loadable(() =>
  import(/* webpackChunkName: "blog-post" */ './index')
);

export default prerenderedLoadable(page);
